export enum TemplatesCardTabEnum {
  RECENT = "Recent",
  TEMPLATES = "Templates",
}
